import { jsPDF } from 'jspdf';
import { PdfHelperFunctions } from './../utils/save-as-pdf-util';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { map, catchError, filter } from 'rxjs/operators';
import { PraticaModel, ReturnErrorModel, ErrorsModel } from './front-office.service';

import v4 from 'uuid4';

export interface SelectInputModel {
  cognome?: string;
  id: number | string;
  descrizione?: string;
  nome?: string;
  mailFrom?: string;
}

export interface BackOfficePraticaModel extends PraticaModel {
  idStatoPratica: { id: number };
  idTipoCriticita?: { id: number };
  id?: number;
  durataProcPrevGg?: number;
  idFasePratica: { id: number };
  idIniziativaSegnalazione: { id: number };
  materie: { id: number }[];
  protocolloAvvio?: string;
  numeroRichiesteEnti?: number;
  numeroIncontri?: number;
  idTipoChiusura?: { id: number };
  idTipoEsito?: { id: number };
  idCircuitoPenitezPratica?: { id: number };
  idTipoProvvedimentoPratica?: { id: number };
  idTipoIscrizioneForoPratica?: { id: number };
  idStrutturaCollocPratica?: { id: number };
  datiGenitori?: any[];
  note?: string;
  organicoIstruttore?: { id: number };
  //consensoPrivacy? : boolean;
}

export interface Carpetta {
  idPratica: number;
  numFascicolo: string;
  oggettoPratica: string;
  numProgrFascicolo: string;
}

export class FascicoloFilter {
  idPratica: number;
  numFascicolo: string;
  oggettoPratica: string;
  numProgrFascicolo: string;

  constructor(carpetta: Carpetta) {
    this.idPratica = carpetta.idPratica;
    this.numFascicolo = carpetta.numFascicolo;
    this.oggettoPratica = carpetta.oggettoPratica;
    this.numProgrFascicolo = carpetta.numProgrFascicolo;
  }
}

@Injectable({
  providedIn: 'root' // TODO : da cambiare
})
export class RicercaPraticheService {

  endPointLocation: string;
  securedEndPointLocation: string;

  constructor(private http: HttpClient) {

    this.endPointLocation = `public/api`;
    this.securedEndPointLocation = `backoffice`;
  }

  private searchFormValues: { [key: string]: string | number } = null;
  private searchFormPaginator: { [key: string]: string | number } = null;

  getSearchFilters() {
    return this.searchFormValues;
  }


  getHtmlTemplate(idTipoDocumento, idPratica) {
    return this.http.get(`backoffice/mail/template/${idTipoDocumento}/pratica/${idPratica}`, { responseType: "text" });
  }

  getHtmlDiniego(idPratica) {
    return this.http.get(`backoffice/pratica/${idPratica}/diniego`, { responseType: "text" });  
  }

  setSearchFilters(value: { [key: string]: string | number }) {
    this.searchFormValues = value;
  }

  getSearchFormPaginator() {
    return this.searchFormPaginator;
  }

  setSearchFormPaginator(value: { [key: string]: string | number }) {
    this.searchFormPaginator = value;
  }

  clearSearchFilters() {
    this.searchFormValues = null;
    this.searchFormPaginator = null;
  }

  getCategorieSoggettoByTipoSoggettoId(idTipoSoggetto: number) {
    if (!idTipoSoggetto) return of([]);
    return this.http.get(`public/api/categorieSoggetto/${idTipoSoggetto}/all`);
  }

  getCriticita() {
    return this.http.get(`public/api/tipoCriticita/all`);
  }

  getStatoCoppia() {
    return this.http.get(`public/api/statoCoppia/all`);
  }

  getTipoItem() {
    return this.http.get(`public/api/tipoItem/all`);
  }

  getTipoEsito() {
    return this.http.get(`public/api/tipoEsito/all`);
  }

  getTipoProv() {
    return this.http.get(`public/api/tipoProvvedimento/all`)
  }

  getTipoChiusura() {
    return this.http.get(`public/api/tipoChiusura/all`);
  }

  getAllegatiIntegrazione(token: string) {
    return this.http.get(`public/api/integrazione/allegato/tipo/richiesta/${token}`);
  }

  inviaIntegrazione(token: string, datiIntegrazione: { documenti: { tipo: string, id: number, file: File, descrizione: string, descrizioneTipo :string } }[]) {
    const multiPartFiles = {};
    const postDoc = datiIntegrazione.map(val => {
      const documento = val.documenti;
      const id = v4();
      multiPartFiles[id] = documento.file;
      return {
        id: documento.id,
        idTipoAllegato: parseInt(documento.tipo, 10),
        descrizioneTipoAllegato : documento.descrizioneTipo, //descrizione del tipo allegato (quella che ricevo)
        idDocumentoIntegrazione :{
          idFile: id,
          nomeFile : documento.file.name || null,
          descrizione: documento.descrizione || null,
          idTipoDocumentoIntegrazione: { id: documento.tipo }
        }
      };
    });
    const dataToSend = this.jsonToFormData({ allegatiDaIntegrare: postDoc });
    Object.keys(multiPartFiles).forEach(key => {
      if (multiPartFiles[key]) {
        dataToSend.append('multipartFiles', multiPartFiles[key], key.toString());
      }
    });

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/form-data');
    return this.http.post(`public/api/pratica/integrazione/richiesta/${token}`, dataToSend, { responseType: "text" });
  }

  comunicazioneChiusura(idPratica : number, data){
    const outPutData = {...data};
    return this.http.post(`backoffice/pratica/comunicazione-chiusura/${idPratica}`, data );
  }

  deleteProcedureById(id: number) {

    return this.http.post(`backoffice/pratica/delete/${id}`, {});
  }

  validateProcedureById(id: number) {
    ///backoffice/pratica/valida/{id}
    return this.http.post(`backoffice/pratica/valida/${id}`, {});
  }

  firstProtocolProcedureById(id: number) {
    ///backoffice/pratica/valida/{id}
    return this.http.post(`backoffice/pratica/protocollazione-iniziale/${id}`, {});
  }

  protocolProcedureById(id: number) {
    ///backoffice/pratica/valida/{id}
    return this.http.post(`backoffice/pratica/protocollazione/${id}`, {});
  }

  getDettaglioPraticaByToken(token: string) {
    return this.http.get(`public/api/pratica/preview/${token}`);
  }

  protocollaDocumentoProcedureById(id: number, documento: { tipo: string, idDoc: string, file: File, descrizione: string }) {
    const protocolFiles = {};
    const rndId = v4(); //creao un rndm id 
    if (documento && documento.file) protocolFiles[rndId] = documento.file;
    const postDoc = {
      descrizione: documento.descrizione || null,
      nomeFile: documento.file && documento.file.name ? documento.file.name : null,
      idTipoDocumentoIntegrazione: { id: documento && documento.tipo ? parseInt(documento.tipo, 10) : null },
      idFile: rndId
    };
    const dataToSend = this.jsonToFormData(postDoc);
    dataToSend.append('allegato', protocolFiles[rndId], rndId.toString());

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/form-data');
    return this.http.post(`backoffice/pratica/${id}/protocolla/documento/`, dataToSend, { headers });
  
  }

  inserisciDocumentoProcedureById(id: number, documento: { tipo: string, idDoc: string, file: File, descrizione: string }) {
    const files = {};
    const rndId = v4();
    if (documento && documento.file) files[rndId] = documento.file;
    const postDoc = {
      descrizione: documento.descrizione || null,
      nomeFile: documento.file && documento.file.name ? documento.file.name : null,
      idTipoDocumentoIntegrazione: { id: documento && documento.tipo ? parseInt(documento.tipo, 10) : null },
      idFile: rndId
    };
    const dataToSend = this.jsonToFormData(postDoc);
    dataToSend.append('allegato', files[rndId], rndId.toString());

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/form-data');
    return this.http.post(`backoffice/pratica/${id}/inserisci/documento/`, dataToSend, { headers });
  }

  protocollaDocumentoById(documento: { idDoc: string}) {
    return this.http.post(`backoffice/pratica/protocolla-doc-item/${documento.idDoc}`, {});
  }

  nuovaCarpettaProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/fascicola/${id}`, {});
  }

  ricercaCarpettaById(idFascicolo: number, idPratica: number) {
    return this.http.get(`backoffice/pratica/search/fascicolo/${idFascicolo}/pratica/${idPratica}`, {});
  }

  salvaFascicolaById(idFascicolo: number, numProgrFascicolo: number, idPratica: number) {
    return this.http.post(`backoffice/pratica/save/fascicolo/${idFascicolo}/numProgr/${numProgrFascicolo}/pratica/${idPratica}`, {});
  }

  verificaAmmissibilitaProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/verifica-ammissibilita/${id}`, {});
  }

  approvaAmmissibilitaProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/approva-ammissibilita/${id}`, {});
  }

  respingiAmmissibilitaProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/respingi-ammissibilita/${id}`, {});
  }

  respingiDiniegoProcedureById(id: number, dati: object) {
    return this.http.post(`backoffice/pratica/respingi-diniego/${id}`, dati);
  }

  proseguiDiniegoProcedureById(id: number, dati: object) {
    return this.http.post(`backoffice/pratica/prosegui-diniego/${id}`, dati);
  }

  goToSezioneAssegnaIstruttoreProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/accedi-assegna-istruttore/${id}`, {});
  }

  assegnaIstruttoreProcedureById(id: number, datiIstruttore: object) {
    return this.http.post(`backoffice/pratica/assegna-istruttore/${id}`, datiIstruttore);
  }

  protocollaAssegnazione(id: number) {
    return this.http.post(`backoffice/pratica/protocollazione/${id}`, {});
  }

  salvaNoteAssegnaById(id: number, datiNoteAssegna: object) {
    return this.http.post(`backoffice/pratica/salva-note-assegna/${id}`, datiNoteAssegna);
  }

  salvaNoteChiusuraById(id: number, datiNoteChiusura: object) {
    return this.http.post(`backoffice/pratica/salva-note-chiusura/${id}`, datiNoteChiusura);
  }

  salvaBozzaMail(id: number, datiMail: object) {
    return this.http.post(`backoffice/pratica/salva-bozza-mail/${id}`, datiMail);
  }

  getBozzaMailByIdPratica(idPratica) {
    return this.http.get(`backoffice/pratica/bozza-mail/${idPratica}`, { responseType: 'text' });
  }

  getBozzaMailComAvvio(idPratica) {
    return this.http.get(`backoffice/pratica/bozza-mail-comunicazione-avvio/${idPratica}`, { responseType: 'text' });
  }

  invioMailById(id: number, email: object) {
    return this.http.post(`backoffice/pratica/invia-email-assegna/${id}`, email);
  }

  getDataPratica(id: number) {
    return this.http.get(`backoffice/pratica/data-inizio/${id}`, { responseType: 'text' });
  }

  salvaComunicazioneAvvio(id: number, datiComAvvio: object) {
    return this.http.post(`backoffice/pratica/salva-comunicazione-avvio/${id}`, datiComAvvio);
  }

  istruttoriaCompleta(id: number) {
    return this.http.post(`backoffice/pratica/istruttoria-completa/${id}`, {});
  }

  mandaAllistruttore(id: number) {
    return this.http.post(`backoffice/pratica/manda-istruttore/${id}`, {});
  }

  chiusuraSenzaDiniegoProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/chiusura/${id}`, {});
  }

  chiusuraConDiniegoProcedureById(id: number, dataDiniego: object) {
    return this.http.post(`backoffice/pratica/chiusura/diniego/${id}`, dataDiniego);
  }

  istruttoriaIncompletaProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/istruttoria-incompleta/${id}`, {});
  }

  richiediIntegrazioneProcedureById(id: number, dataToSend: object) {
    return this.http.post(`backoffice/pratica/richiesta-integrazione/${id}`, dataToSend);
  }

  chiusuraTerminiScadutiProcedureById(id: number) {
    return this.http.post(`backoffice/pratica/chiusura-termini/${id}`, {});
  }

  approvaNotaPA(id: number, dataToSend: object) {
    return this.http.post(`backoffice/pratica/approva-nota-pa/${id}`, dataToSend);
  }

  rifiutoNotaPA(id: number, dataToSend: object) {
    return this.http.post(`backoffice/pratica/rifiuto-nota-pa/${id}`, dataToSend);
  }

  validaComunicazioneFinale(id: number) {
    return this.http.post(`backoffice/pratica/valida-comunicazione-finale/${id}`, {});
  }

  rifiutaComunicazioneFinale(id: number, dataToSend: object) {
    return this.http.post(`backoffice/pratica/rifiuta-comunicazione-finale/${id}`, dataToSend);
  }

  inviaComunicazioneFinale(id: number) {
    return this.http.post(`backoffice/pratica/invia-comunicazione-finale/${id}`, {});
  }

  archiviaPratica(id: number) {
    return this.http.post(`backoffice/pratica/archivia-pratica/${id}`, {});
  }

  comunicazionePerChiusura(id: number, dataToSend: object) {
    return this.http.post(`backoffice/pratica/comunicazione-chiusura-citt/${id}`, dataToSend);
  }

  inviaAllApprovazione(id: number, mailData: object) {
    return this.http.post(`backoffice/pratica/invia-per-approvazione/${id}`, mailData);
  }

  getIstruttori() {
    return this.http.get(`${this.endPointLocation}/istruttori/all`);
  }
  getIstruttoriByIdIstituto(idIstitutoGaranzia: number) {
    if (!idIstitutoGaranzia) return of([]);
    return this.http.get(`backoffice/pratica/utenti/istruttori/${idIstitutoGaranzia}/all`);
  }
  getResponsabiliByIdIstituto(idIstitutoGaranzia: number) {
    if (!idIstitutoGaranzia) return of([]);
    return this.http.get(`backoffice/pratica/utenti/responsabili/${idIstitutoGaranzia}/all`);
  }
  getStatiPraticaByIdFasi(idFase: number | string) {
    if (idFase == null || idFase == undefined) return of([]);
    return this.http.get(`${this.endPointLocation}/pratica/stato/${idFase}/all`);
  }
  getFasiPratica() {
    return this.http.get(`${this.endPointLocation}/pratica/fase/all`);
  }

  getMateriaByIstitutoId(idIstituto: number | string, idPratica: number | string) {
    if (!idPratica && idIstituto) {
      return this.http.get(`${this.endPointLocation}/pratica/materie/${idIstituto}`);
    }
    else if (idPratica) {
      return this.http.get(`${this.endPointLocation}/pratica/materie/pratica/${idPratica}`);
    }
    else {
      return of([]);
    }
  }

  getAnnoPratica() {
    return this.http.get(`${this.endPointLocation}/anniavvio/all`);
  }

  getProvice() {
    return this.http.get(`${this.endPointLocation}/provincia/all`); // è ripetuta ma così non richiamo un intero service per una o due chiamate;
  }

  getIniziativa() {
    return this.http.get(`${this.endPointLocation}/pratica/iniziativesegnalazione`); // è ripetuta ma così non richiamo un intero service per una o due chiamate;
  }

  getTipoSegnalazione() {
    return this.http.get(`${this.endPointLocation}/tipoSegnalazione/all`);
  }

  getTipoServizio() {
    return this.http.get(`public/api/tipoServizio/all`);
  }

  getCircuitoPen() {
    return this.http.get(`public/api/circuitoPenitenziario/all`);
  }

  getStrutturaCollocazione() {
    return this.http.get(`public/api/strutturaCollocazione/all`);
  }

  getTipoForoIscrizione() {
    return this.http.get(`public/api/tipoForoIscrizione/all`);
  }

  isUserAssignedToPratica(idPratica: number) {
    return this.http.get(`backoffice/pratica/${idPratica}/assigned/currentUser`);
  }

  getIstitutiGaranzia() {
    return this.http.get(`${this.endPointLocation}/istitutoGaranzia/all`);
  }

  getIniziativeSegnalazione() {
    return this.http.get(`${this.endPointLocation}/pratica/iniziativesegnalazione`);
  }

  getPraticaById(idPratica: number) {
    return this.http.get(`backoffice/pratica/dettaglio/${idPratica}`).pipe(map((a: any) => {
      const keysArray: string[] = ['richiedenti', 'intestatari', 'controparti', 'datiGenitori'];
      Object.keys(a).forEach(key => {

        if (a[key] && keysArray.indexOf(key) === -1 && a[key].id) {
          a[key] = a[key].id;
        }
      })
      a['idIniziativaSegnalazione'] = a.idIniziativaSegnalazione || null; //???
      keysArray.forEach(key => {
        if (a[key] === null) a[key] = [];
        a[key].forEach((val, i) => {
          Object.keys(a[key][i]).forEach(key_in => {
            if (a[key][i][key_in] && a[key][i][key_in].id) {
              a[key][i][key_in] = a[key][i][key_in].id;
            }
            if (a[key][i][key_in] === null) {
              delete a[key][i][key_in];
            }
          })
        })

      })
      return a;
    }))
  }

  getVisualizzaPraticaByToken(token: string) {
    return this.http.get(`public/api/pratica/viewDettaglio/${token}`).pipe(map((a: any) => {
      const keysArray: string[] = ['richiedenti', 'intestatari', 'controparti', 'datiGenitori'];
      Object.keys(a).forEach(key => {

        if (a[key] && keysArray.indexOf(key) === -1 && a[key].id) {
          a[key] = a[key].id;
        }
      })
      a['idIniziativaSegnalazione'] = a.idIniziativaSegnalazione || null; //???
      keysArray.forEach(key => {
        if (a[key] === null) a[key] = [];
        a[key].forEach((val, i) => {
          Object.keys(a[key][i]).forEach(key_in => {
            if (a[key][i][key_in] && a[key][i][key_in].id) {
              a[key][i][key_in] = a[key][i][key_in].id;
            }
            if (a[key][i][key_in] === null) {
              delete a[key][i][key_in];
            }
          })
        })

      })
      return a;
    }))
  }


  getPratichePaginated(filter: { [key: string]: any }, isManagement: boolean = false) {
    const filterObj = {};
    Object.keys(filter).forEach(key => {
      if (filter[key] !== null && filter[key] !== undefined && filter[key] !== '') {

        if (key === 'istitutoGaranzia') filterObj['idIstitutoGaranzia'] = filter.istitutoGaranzia;
        else filterObj[key] = filter[key];
      }
    });
    filterObj['sort'] = 'data_inizio_stato,desc';
    if (isManagement) return this.http.get(`backoffice/pratica/gestione/all`, { params: filterObj as any });
    else return this.http.get(`backoffice/pratica/all`, { params: filterObj as any });
  }

  getDownloadLinkXLS(filter: { [key: string]: any }) {
    //let queryPram ='?';
    let queryParams = new URLSearchParams();
    queryParams.append('sort', 'data_inizio_stato,desc');
    Object.keys(filter).forEach(key => {
      if (filter[key] !== null && filter[key] !== undefined && filter[key] !== '') {
        if (key === 'istitutoGaranzia') queryParams.append('idIstitutoGaranzia', filter.istitutoGaranzia); //queryPram = `${queryPram}idIstitutoGaranzia=${filter.istitutoGaranzia}&`; //filterObj['idIstitutoGaranzia'] = filter.istitutoGaranzia;
        else queryParams.append(key, filter[key]);
      }
    });
    return `backoffice/pratica/all/gestione/excel?${queryParams.toString()}`;
  }

  getRicercaDownloadLinkXLS(filter: { [key: string]: any }) {
    //let queryPram ='?';
    let queryParams = new URLSearchParams();
    queryParams.append('sort', 'data_inizio_stato,desc');
    Object.keys(filter).forEach(key => {
      if (filter[key] !== null && filter[key] !== undefined && filter[key] !== '') {
        if (key === 'istitutoGaranzia') queryParams.append('idIstitutoGaranzia', filter.istitutoGaranzia);
        else queryParams.append(key, filter[key]);
      }
    });
    return `backoffice/pratica/all/excel?${queryParams.toString()}`;
  }

  getPratichePerIstitutoXLS() {
    return 'backoffice/pratica/all/pratiche-per-istituto/excel/';
  }

  getNumeroPratichePerIstituto() {
    return this.http.get('backoffice/pratica/numero-pratiche-per-istituto', {});
  }

  getDettaglioPratichePerIstitutoXLS() {
    return 'backoffice/pratica/all/dettaglio-pratiche-per-istituto/excel';
  }

  getNumeroDettaglioPratichePerIstituto() {
    return this.http.get('backoffice/pratica/numero-dettaglio-pratiche-per-istituto', {});
  }

  getPraticheAperteXLS() {
    return 'backoffice/pratica/all/pratiche-aperte/excel';
  }

  getNumeroPraticheAperte() {
    return this.http.get('backoffice/pratica/numero-pratiche-aperte', {});
  }

  getSintesiGlobaleXLS() {
    return 'backoffice/pratica/all/sintesi-globale-pratiche/excel';
  }

  getNumeroSintesiGlobale() {
    return this.http.get('backoffice/pratica/numero-sintesi-globale-pratiche', {});
  }

  findCarpette(carp: any) {
    const fascicoloFilter = new FascicoloFilter(carp);
    Object.keys(fascicoloFilter).forEach(x => {
      if (fascicoloFilter[x] == null || fascicoloFilter[x] === '')
        delete fascicoloFilter[x];
    });
    return this.http.get(`backoffice/pratica/fascicoli/filter`, { params: fascicoloFilter as any }) as Observable<any>;
  }

  findDocumento(doc: any) {
    Object.keys(doc).forEach(x => {
      if (doc[x] == null || doc[x] === '')
        delete doc[x];
    });
    return this.http.get(`backoffice/pratica/documento-protocollato/filter`, { params: doc as any }) as Observable<any>;

   //return null;
  }

  private buildFormData(formData, data, parentKey?) {
    if (data && Array.isArray(data) && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key);
      });
    } else {
      const value = data;

      if (value !== null) formData.append(parentKey, value);
    }
  }

  private jsonToFormData(data) {
    const formData = new FormData();

    this.buildFormData(formData, data);

    return formData;
  }


  //SPOSTAMI -->
  async postConfermaPratica(formData: any, id: number, praticaFormData: any, isUpdate: boolean = false, oldPratica: { [key: string]: any } = null, extraDataFormValue: any = null) {
    const headers = new HttpHeaders();
    const richiedentiFiles = {};
    const allegatiFiles = {};
    const intestatariFiles = {};
    const praticaFiles = {};
    const idPratica = isUpdate && oldPratica !== null ? oldPratica.id : null;
    if (praticaFormData.idStatoPratica === 10) {
      await PdfHelperFunctions.getPdf('dati-pratica-container').then((doc: jsPDF) => {
        const rndId = v4();
        const docPratica = this.dataURIStringtoFile(doc.output('datauristring'), 'test007');
        praticaFiles[rndId] = docPratica;
      });
    }
    let postData: BackOfficePraticaModel = {
      istitutoGaranzia: { id },
      materie: praticaFormData.materie ? praticaFormData.materie.map(val => { return { id: val } }) : [],
      idIniziativaSegnalazione: { id: parseInt(formData.idIniziativaSegnalazione, 10) },
      idFasePratica: { id: praticaFormData.idFasePratica || null },
      idStatoPratica: { id: praticaFormData.idStatoPratica || null },
      idRelazione: formData.idRelazione,
      idRapportoIntestatario: formData.idRapportoIntestatario,
      tipoSegnalazione: formData.tipoSegnalazione,
      oggetto: formData.oggetto ? formData.oggetto : praticaFormData.oggetto ? praticaFormData.oggetto : null,
      richiedenti: formData.richiedenti.map((val, i) => {
        const rndId = v4();
        if (val.documenti && val.documenti.file) {
          // if (!isUpdate)
            richiedentiFiles[rndId] = val.documenti.file;
        }
        return this.mapForRequest(val, i, isUpdate, extraDataFormValue, rndId);
      }),
      intestatari: formData.intestatari.map((val, i) => {
        const rndId = v4();
        const idDocumentoGenitore = v4();
        const rndIdDeleghe = v4();
        if (val.documentoGenitore && val.documentoGenitore.file) {
          intestatariFiles[idDocumentoGenitore] = val.documenti.file;
        }
        if (val.documenti && val.documenti.file)
          intestatariFiles[rndId] = val.documenti.file;
        if (val.delega && val.delega.file)
          intestatariFiles[rndIdDeleghe] = val.delega ? val.delega.file : null;
        return this.mapForRequest(val, i, isUpdate, extraDataFormValue, rndId, rndIdDeleghe, idDocumentoGenitore);
      }),
      allegatiGenerici: formData.allegati.map((val, index: number) => {
        const rndId = v4();
        if (val.documenti && val.documenti.file && val.documenti.file.size) {
          allegatiFiles[rndId] = val.documenti.file;
          return {
            descrizione: val.documenti.descrizione || null,
            nomeFile: val.documenti.file ? val.documenti.file.name : null,
            idTipoDocumentoIntegrazione: { id: val.documenti.tipo ? parseInt(val.documenti.tipo, 10) : null },
            idFile: rndId || null,
            ordineAllegato: index,
          };
        } else return null;
      }).filter((file) => file !== null),
      controparti: formData.controparti.filter(val => this.plainObjectProprieryChecker(val, ['personaFisica'])).map((val, index: number) => {
        return {
          denominazione: val.cognomeDenominazione,
          nome: val.nome ? val.nome : null,
          sesso: val.sesso ? val.sesso : null,
          codiceFiscale: val.codiceFiscale ? val.codiceFiscale : null,
          personaFisica: val.personaFisica !== null && val.personaFisica !== undefined ? val.personaFisica : null,
          indirizzo: val.indirizzo,
          idProv: { id: val.idProv ? parseInt(val.idProv, 10) : null },
          idComune: { id: val.idComune ? parseInt(val.idComune, 10) : null },
          cap: val.cap,
          email: val.email,
          ordineControparte: index,
          id: val.id || null,
          idTipoServizio: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue && extraDataFormValue.controparti && extraDataFormValue.controparti[index] ? extraDataFormValue.controparti[index] : null, 'idTipoServizio', true)
        };
      }),
      recaptcha: formData.recaptcha,
      descQuestione: formData.descQuestione,
      descIntrapreso: formData.descIntrapreso,
      consensoPrivacy: formData.consensoPrivacy,
      //extra data
      idTipoCriticita: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idTipoCriticita', true),
      numeroRichiesteEnti: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'numeroRichiesteEnti'),
      numeroIncontri: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'numeroIncontri'),
      durataProcPrevGg: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'durataProcPrevGg'),
      idTipoChiusura: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idTipoChiusura', true),
      idTipoEsito: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idTipoEsito', true),
      idCircuitoPenitezPratica: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idCircuitoPenitezPratica', true),
      idStrutturaCollocPratica: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idStrutturaCollocPratica', true),
      idTipoProvvedimentoPratica: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idTipoProvvedimentoPratica', true),
      idTipoIscrizioneForoPratica: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'idTipoIscrizioneForoPratica', true),
      note: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'note'),
      organicoIstruttore: this.checkExtraDataFirstLevel(isUpdate, extraDataFormValue, 'organicoIstruttore', true),
      datiGenitori: this.getDatiGenitori(isUpdate, extraDataFormValue)
    };
    if (isUpdate && idPratica !== null && idPratica !== undefined) {
      postData = { ...postData, id: idPratica, protocolloAvvio: oldPratica.protocolloAvvio };
    }
    const dataToSend = this.jsonToFormData(postData);
    Object.keys(richiedentiFiles).forEach((key) => {
      if (richiedentiFiles[key] instanceof File) {
        dataToSend.append(
            "richiedentiFiles",
            richiedentiFiles[key],
            key.toString()
        );
      }
    });
    Object.keys(intestatariFiles).forEach((key) => {
      if (intestatariFiles[key] instanceof File) {
        dataToSend.append(
            "intestatariFiles",
            intestatariFiles[key],
            key.toString()
        );
      }
    });
    Object.keys(allegatiFiles).forEach((key) => {
      if (allegatiFiles[key] instanceof File) {
        dataToSend.append("allegatiFiles", allegatiFiles[key], key.toString());
      }
    });
    Object.keys(praticaFiles).forEach((key) => {
      if (praticaFiles[key] instanceof Blob || praticaFiles[key] instanceof File)
        dataToSend.append('praticaFiles', praticaFiles[key], key.toString());
    });

    headers.append('Content-Type', 'application/form-data');

    const endpoint: string = !isUpdate ? `${this.securedEndPointLocation}/pratica/nuova-pratica/conferma` : `${this.securedEndPointLocation}/pratica/update/${idPratica}`;

    return this.http.post(endpoint, dataToSend, { headers })
      .pipe(
        catchError(err => {
          console.log(err);
          return this.handleError<Array<{ id: number, nome: string }>>('post data', []);
        })
      );
  }

  dataURIStringtoFile(dataURI: string, fileName: string) {
    const byteString = (dataURI.split(',')[0].indexOf('base64') >= 0)
      ? atob(dataURI.split(',')[1]) 
      : unescape(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    const blob: any = new Blob([ia], {type: mimeString});
    blob.lastModifiedDate = new Date();
    blob.lastModified = Date.now();
    blob.name = fileName;
    return blob as File;
  }

  private checkExtraDataFirstLevel(isUpdate: boolean, extraData: any, key: string, hasId: boolean = false) {
    if (!isUpdate || (isUpdate && extraData && (extraData[key] === null || extraData[key] === undefined)) || (isUpdate && !extraData)) return null;
    else if (hasId) return { id: parseInt(extraData[key], 10) };
    else return extraData[key];
  }


  private getDatiGenitori(isUpdate, extraData) {
    if (this.checkExtraDataFirstLevel(isUpdate, extraData, 'datiGenitori') !== null) {
      return extraData.datiGenitori.map((datoG, index: number) => {
        return {
          id: datoG.id || null,
          etaPadre: datoG.etaPadre || null,
          etaMadre: datoG.etaMadre || null,
          provResidPadre: this.checkExtraDataFirstLevel(isUpdate, datoG, 'provResidPadre', true),
          provResidMadre: this.checkExtraDataFirstLevel(isUpdate, datoG, 'provResidMadre', true),
          cittadinanzaPadre: this.checkExtraDataFirstLevel(isUpdate, datoG, 'cittadinanzaPadre', true),
          cittadinanzaMadre: this.checkExtraDataFirstLevel(isUpdate, datoG, 'cittadinanzaMadre', true),
          statoCoppia: this.checkExtraDataFirstLevel(isUpdate, datoG, 'statoCoppia', true),
        };
      });
    }
    else return [];
  }

  private mapForRequest(val: any, i: number, isUpdate: boolean, extraDataFormValue: any, rndId: string, rndIdDeleghe?: string, rndIdGenitore?: string) {
    let extraDataRichiedente = null;
    if (isUpdate && extraDataFormValue && extraDataFormValue.richiedenti && extraDataFormValue.richiedenti[i]) {
      extraDataRichiedente = extraDataFormValue.richiedenti[i];
    }

    const returnObj = {
      id: val.id || null,
      idTipoSoggetto: { id: val.idTipoSoggetto },
      codiceFiscale: val.codiceFiscale,
      cognomeDenominazione: val.cognomeDenominazione,
      partitaIva: val.partitaIva,
      nome: val.nome,
      sesso: val.sesso,
      idCittadinanza: {
        id: val.idCittadinanza,
      },
      idCittadinanzaAltro: {
        id: val.idCittadinanzaAltro,
      },
      idStato: { id: val.idStato && val.idStato !== 'null' ? parseInt(val.idStato, 10) : null },
      indirizzo: val.indirizzo,
      idProv: { id: val.idProv ? parseInt(val.idProv, 10) : null },
      idComune: { id: val.idComune ? parseInt(val.idComune, 10) : null },
      cap: val.cap || null,
      telefono: val.telefono,
      altroTelefono: val.altroTelefono,
      fax: val.fax,
      email: val.email,
      idDocumentoRiconoscimento: val.documenti && val.documenti.file ? {
        descrizione: val.documenti.descrizione || null,
        nomeFile: val.documenti.file ? val.documenti.file.name : null,
        idTipoDocumentoIntegrazione: { id: val.documenti && val.documenti.tipo ? parseInt(val.documenti.tipo, 10) : null },
        idFile: rndId ? rndId : null, // idDoc?, !isUpdate
        idDocumento: isUpdate && val.documenti && val.documenti.idDoc ? val.documenti.idDoc : null
      } : null,

      idDocumentoDelega: val.delega && val.delega.file ? {
        descrizione: val.delega ? val.delega.descrizione : null,
        nomeFile: val.delega && val.delega.file ? val.delega.file.name : null,
        idTipoDocumentoIntegrazione: { id: val.delega ? parseInt(val.delega.tipo, 10) : null },
        idFile: rndIdDeleghe ? rndIdDeleghe : null, // idDoc?, !isUpdate
        idDocumento: isUpdate && val.delega && val.delega.idDoc ? val.delega.idDoc : null
      } : null,
      idDocumentoGenitore: val.documentoGenitore && val.documentoGenitore.file ? {
        descrizione: val.documentoGenitore ? val.documentoGenitore.descrizione : null,
        nomeFile: val.documentoGenitore && val.documentoGenitore.file ? val.documentoGenitore.file.name : null,
        idTipoDocumentoIntegrazione: { id: val.documentoGenitore ? parseInt(val.documentoGenitore.tipo, 10) : null },
        idFile: !isUpdate && rndIdGenitore ? rndIdGenitore : null, //idDoc?
        idDocumento: isUpdate && val.documentoGenitore && val.documentoGenitore.idDoc ? val.documentoGenitore.idDoc : null
      } : null,
      dataNascita: this.convertDate(val.dataNascita || null),
      idProvNascita: {
        id: val.idProvNascita && val.idProvNascita !== 'null' ? parseInt(val.idProvNascita, 10) : null
      },
      idComuneNascita: {
        id: val.idComuneNascita && val.idComuneNascita !== 'null' ? parseInt(val.idComuneNascita, 10) : null
      },
      idNazionalitaNascita: {
        id: val.idNazionalitaNascita && val.idNazionalitaNascita !== 'null' ? parseInt(val.idNazionalitaNascita, 10) : null
      },
      idStatoNascita: {
        id: val.idStatoNascita && val.idStatoNascita !== 'null' ? parseInt(val.idStatoNascita, 10) : null
      },

      idLuogoRestrizione: {
        id: val.idLuogoRestrizione ? parseInt(val.idLuogoRestrizione, 10) : null
      },
      idLuogoRestrizioneCarcere: {
        id: val.idLuogoRestrizioneCarcere ? parseInt(val.idLuogoRestrizioneCarcere, 10) : null
      },
      //intDiffuso: val.intDiffuso || null,
      ordineSoggetto: i,
      idRelazione: val.idRelazione && val.idRelazione !== 'null' ? parseInt(val.idRelazione, 10) : null,
      idRapportoIntestatario: { id: val.idRapportoIntestatario && val.idRapportoIntestatario !== 'null' ? parseInt(val.idRapportoIntestatario, 10) : null },
      personaFisica: val.personaFisica,
      principale: val.principale ? val.principale : false,
      copiato: val.copiato ? true : false,
      //extra data 
      eta: this.checkExtraDataFirstLevel(isUpdate, extraDataRichiedente, 'eta'),
      professione: this.checkExtraDataFirstLevel(isUpdate, extraDataRichiedente, 'professione'),
      titoloStudio: this.checkExtraDataFirstLevel(isUpdate, extraDataRichiedente, 'titoloStudio'),
      idCategoriaSoggetto: this.checkExtraDataFirstLevel(isUpdate, extraDataRichiedente, 'idCategoriaSoggetto', true),
    };
    /*if(rndIdDeleghe){

    }*/
    return returnObj;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<ReturnErrorModel> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      const richiedentiErrors: ErrorsModel[] = [];
      const intestatariErrors: ErrorsModel[] = [];
      const allegatiErrors: ErrorsModel[] = [];
      const contropartiErrors: ErrorsModel[] = [];
      const generalErrors: ErrorsModel[] = [];
      if (error && error.status && error.status === 403) {
        const returnObject: ReturnErrorModel = {
          error: true,
          richiedenti: richiedentiErrors,
          intestatari: intestatariErrors,
          generali: generalErrors,
          allegati: allegatiErrors,
          controparti: contropartiErrors,
          status: 403
        };
        return of(returnObject);
      }
      if (typeof (error.error) !== 'string') Object.keys(error.error).forEach(key => {
        const errorObj: ErrorsModel = { message: null, order: null, key: null };
        errorObj.message = error.error[key];
        // if (key.startsWith('richiedenti') || key.startsWith('intestatari') ||  key.startsWith('alleagti') || key.startsWith('controparti') ) {

        if (key.split('.').length > 1) {
          const splitKey = key.split('.');
          errorObj.key = splitKey[1];
          if (splitKey[0].split('[').length > 1) {
            errorObj.order = parseInt(splitKey[0].split('[')[1].replace(']', ''), 10);
          }
          if (key.startsWith('richiedenti')) {
            richiedentiErrors.push(errorObj);
          } else if (key.startsWith('intestatari')) {
            intestatariErrors.push(errorObj);
          } else if (key.startsWith('allegatiGenerici')) {
            allegatiErrors.push(errorObj);
          } else if (key.startsWith('controparti')) {
            contropartiErrors.push(errorObj);
          }
        } else {
          errorObj.key = key;
          generalErrors.push(errorObj);
        }
      }

      );
      const returnObject: ReturnErrorModel = {
        error: true,
        richiedenti: richiedentiErrors,
        intestatari: intestatariErrors,
        generali: generalErrors,
        allegati: allegatiErrors,
        controparti: contropartiErrors,
      };
      return of(returnObject);
    };
  }

  private convertDate(inputFormat) {
    if (!inputFormat) return null;
    const pad = (s) => {
      return (s < 10) ? '0' + s : s;
    };
    const d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-');
  }

  plainObjectProprieryChecker(obj: object, keysToAvoid?: string[]): boolean {
    const keys = Object.keys(obj);
    for (let key of keys) {
      if (keysToAvoid.indexOf(key) !== -1) continue;
      if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '' && obj[key] !== 'null')
        return true;
    }
    return false;
  }

  //SPOSTAMI <---
}
